<template>
  <el-dialog
    title="商品拆分"
    :visible.sync="visible"
    width="900px"
    @close="handleClose"
    append-to-body
  >
    <!-- 商品搜索 -->
    <div class="search-section">
      <el-input
        v-model="searchKeyword"
        ref="searchInput"
        placeholder="请输入商品名称或编号"
        @keydown.enter.native.prevent="handleEnterKey"
        @keydown.up.native.prevent="navigateUp"
        @keydown.down.native.prevent="navigateDown"
      >
      </el-input>
    </div>

    <!-- 商品列表 -->
    <div class="products-section">
      <h4>商品列表</h4>
      <el-table
        :data="products"
        @row-click="selectProduct"
        highlight-current-row
        max-height="200"
        :row-class-name="getRowClassName"
        ref="productTable"
      >
        <el-table-column prop="bgmName" label="商品名称" min-width="150" />
        <el-table-column prop="spec" label="规格" width="150" />
        <el-table-column prop="num" label="库存数量" width="100" align="center" />
        <el-table-column prop="batchno" label="批号" width="100" />
        <el-table-column prop="prodate" label="生产日期" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.prodate ? new Date(scope.row.prodate).toLocaleDateString() : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expidate" label="失效日期" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.expidate ? new Date(scope.row.expidate).toLocaleDateString() : '-' }}</span>
          </template>
        </el-table-column>
       
      </el-table>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="performSplit"
        :disabled="!canSplit"
        :loading="splitting"
      >
        {{ splitting ? '拆分中...' : '确认拆分' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SplitItemDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: Number,
      default: ''
    },
    curDate: {
      type: Number,
      default: ''
    },
    curTime: {
      type: Number,
      default: ''
    },
    day: {
      type: Number,
      default: ''
    },
    week: {
      type: Number,
      default: ''
    },
    isZero: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      searchKeyword: '',
      searching: false,
      products: [],
      selectedProduct: null,
      selectedIndex: -1,
      splitForm: {
        splitQuantity: 1
      },
      splitting: false
    }
  },
  computed: {
    canSplit() {
      return this.selectedProduct && this.selectedProduct.num > 0
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      }
    }
  },
  methods: {

    // 处理回车键事件
    async handleEnterKey() {
      if (this.selectedProduct) {
        // 如果已有选中商品，直接执行拆分
        await this.performSplit()
      } else {
        // 否则执行搜索
        await this.searchProducts()
      }
    },

    // 搜索商品
    async searchProducts() {
        if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        this.$message.warning('请输入商品名称')
        this.$refs.searchInput.focus()
        return
      }
      try {
        // 调用搜索API
        const response = await this.$http.getRetailBgmInfo({
            storeId: this.storeId,
            curDate: this.curDate,
            curTime: this.curTime,
            day: this.day,
            week: this.week,
            bgmName: this.searchKeyword,
            isCl: 1,
            isZero:this.isZero
        })
        if (response.status == 200) {
          this.products = response.result || []
          // 搜索后默认选中第一条数据
          if (this.products.length > 0) {
            this.selectedIndex = 0
            this.selectProductByIndex(0)
          }
        }
      } catch (error) {
        console.error('搜索商品失败:', error)
        this.$message.error('搜索商品失败')
      }
    },
    
    // 上下键导航
    navigateUp() {
      if (this.products.length === 0) return
      if (this.selectedIndex > 0) {
        this.selectedIndex--
        this.selectProductByIndex(this.selectedIndex)
      }
    },
    
    navigateDown() {
      if (this.products.length === 0) return
      if (this.selectedIndex < this.products.length - 1) {
        this.selectedIndex++
        this.selectProductByIndex(this.selectedIndex)
      }
    },
    
    // 根据索引选择商品
    selectProductByIndex(index) {
      if (index >= 0 && index < this.products.length) {
        const product = this.products[index]
        this.selectedProduct = { ...product }
        this.splitForm.splitQuantity = 1
        this.selectedIndex = index
        // 滚动到选中行
        this.$nextTick(() => {
          if (this.$refs.productTable) {
            this.$refs.productTable.setCurrentRow(product)
          }
        })
      }
    },
    
    // 点击选择商品
    selectProduct(product) {
      const index = this.products.findIndex(p => p === product)
      this.selectProductByIndex(index)
    },
    
    // 获取行样式
    getRowClassName({ row, rowIndex }) {
      if (rowIndex === this.selectedIndex) {
        return 'selected-row'
      }
      return ''
    },
    
    // 执行拆分
    async performSplit() {
      // if (!this.canSplit) {
      //   this.$message.warning('该商品无法拆分，库存数量必须大于1')
      //   return
      // }
      
      this.splitting = true
      try {
        // 调用拆分API
        const response = await this.$http.splitSingleDirectSplit({
            storeId: this.storeId,
            batchno: this.selectedProduct.batchno,
            bgmId: this.selectedProduct.bgmId,
            expidate: this.selectedProduct.expidate,
            prodate: this.selectedProduct.prodate,
        
        })
       if(response.status == 200){
        this.$message.success('商品拆分成功')
        this.$emit('confirm')
        this.handleClose()
       }else{
        this.$message.error(response.message)
       }
      } catch (error) {
        console.error('拆分失败:', error)
        this.$message.error('拆分失败')
      } finally {
        this.splitting = false
      }
    },
    
    // 关闭对话框
    handleClose() {
      this.$emit('close')
      this.resetData()
    },
    
    // 重置数据
    resetData() {
      this.searchKeyword = ''
      this.products = []
      this.selectedProduct = null
      this.selectedIndex = -1
      this.splitForm.splitQuantity = 1
    }
  }
}
</script>

<style scoped>
.search-section {
  margin-bottom: 20px;
}

.products-section {
  margin-bottom: 20px;
}

.products-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.selected-row {
  background-color: #ecf5ff !important;
}

.dialog-footer {
  text-align: right;
}
</style>
